import { ReferenceDataService } from '@/services';
import Snackbar from '@/classes/snackbar';

export default {
  getSmtpDetails: async ({ commit, dispatch }) => {
    const response = await ReferenceDataService.getSmtpDetails().catch(() => {
      dispatch('createSnackbarMessage', {
        type: Snackbar.TYPE.ERROR,
        message: {
          i18nKey: 'errors.retrievingSmtpDetails'
        }
      });
    });
    if (response) {
      commit('setSmtpDetails', response);
    }
  }
};
